import { z } from "zod";

export const SUB_CATEGORY_FORM_SCHEMA = z.object({
  name: z.string().min(1, "Name is required"),
  nameAr: z.string().min(1, "Arabic name is required"),
  image: z
    .string()
    .url("Please enter a valid URL")
    .min(1, "Image URL is required"),
  id: z
    .string()
    .min(1, "ID is required")
    .regex(
      /^[a-z0-9-]+$/,
      "ID can only contain lowercase letters, numbers, and hyphens",
    ),
});

export type SubCategoryFormData = z.infer<typeof SUB_CATEGORY_FORM_SCHEMA>;
